/* <artist-photos>: opens a photograph large, with previous / next.
   Without it, each photograph is a plain link to the image. */
(() => {
  if (customElements.get('artist-photos')) return;

  const pad = (n) => String(n).padStart(2, '0');

  class ArtistPhotos extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.items = [...this.querySelectorAll('[data-photo]')];
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.items.length) return;
      if (this.ready) return;
      this.ready = true;

      this.stage = this.dialog.querySelector('[data-photo-stage]');
      this.caption = this.dialog.querySelector('[data-photo-caption]');
      this.counter = this.dialog.querySelector('[data-photo-counter]');
      this.index = 0;

      this.items.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(i);
        });
      });

      this.dialog.querySelector('[data-photo-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-photo-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.dialog.querySelector('[data-photo-next]').addEventListener('click', () => this.show(this.index + 1));

      // A click on the empty ground around the photograph closes it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target === this.stage) this.dialog.close();
      });

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const rtl = document.documentElement.dir === 'rtl';
        const forward = (event.key === 'ArrowRight') !== rtl;
        this.show(this.index + (forward ? 1 : -1));
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.overflow || '';
        this.stage.replaceChildren();
        const item = this.items[this.index];
        if (item) item.focus({ preventScroll: true });
      });
    }

    open(i) {
      this.overflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.show(i);
      this.dialog.showModal();
      this.dialog.querySelector('[data-photo-close]').focus();
    }

    show(i) {
      const total = this.items.length;
      this.index = (i + total) % total;
      const item = this.items[this.index];
      const text = item.dataset.caption || '';

      const img = new Image();
      img.className = 'photo-box__img';
      img.alt = text;
      img.sizes = '100vw';
      if (item.dataset.srcset) img.srcset = item.dataset.srcset;
      img.src = item.href;
      this.stage.replaceChildren(img);

      this.caption.textContent = text;
      this.caption.hidden = !text;
      this.counter.textContent = total > 1 ? `${pad(this.index + 1)} / ${pad(total)}` : '';
      this.dialog.querySelectorAll('.photo-box__nav').forEach((nav) => (nav.hidden = total < 2));
    }
  }

  customElements.define('artist-photos', ArtistPhotos);
})();
